import React from 'react';
import { withTranslation } from 'react-i18next';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { Widget } from '../components/widget';
import asyncComponent from '../components/hoc/asyncComponent/asyncComponent';

const AsyncExpand = asyncComponent(() => import('../components/expand/expand'));
const AsyncExpandSettings = asyncComponent(() =>
  import('../components/expandSettings/expandSettings'),
);
const AsyncSettings = asyncComponent(() =>
  import('../components/settings/settings'),
);
const AsyncSettingsMobile = asyncComponent(() =>
  import('../components/settingsMobile/settingsMobile'),
);

const RauterApp = ({ isMobile, isRtl, locale }) => {
  return (
    <Router>
      <Switch>
        <Route exact path="/ig_business_app">
          <div dir={isRtl ? 'rtl' : 'ltr'}>
            <Widget isRtl={isRtl} isMobile={isMobile} />
          </div>
        </Route>
        <Route exact path="/ig_business_app/expand">
          <div dir={isRtl ? 'rtl' : 'ltr'}>
            <AsyncExpand isRtl={isRtl} isMobile={isMobile} />
          </div>
        </Route>
        <Route exact path="/ig_business_app/story">
          <div dir={isRtl ? 'rtl' : 'ltr'}>
            <AsyncExpand isRtl={isRtl} isStory isMobile={isMobile} />
          </div>
        </Route>
        <Route exact path="/ig_business_app/settings">
          {isMobile ? (
            <AsyncSettingsMobile />
          ) : (
            <AsyncSettings locale={locale} />
          )}
        </Route>
        <Route exact path="/ig_business_app/expandSettings">
          <AsyncExpandSettings />
        </Route>
      </Switch>
    </Router>
  );
};

export default withTranslation()(RauterApp);
